import React, { useState } from "react";
import { MdOutlineReportProblem } from "react-icons/md";
import ConfirmPopup from "../../../ConfirmPopup/ConfirmPopup";

interface ReportMistakeButtonProps {
  isReported: boolean;
  onReportedChange: (reported: boolean) => void;
}

const ReportMistakeButton: React.FC<ReportMistakeButtonProps> = ({
  isReported,
  onReportedChange,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="sv-action-btn sv-btn-mistake"
        onClick={() => isReported ? onReportedChange(false) : setOpen(true)}
      >
        <span className="sv-btn-text">
          {isReported ? "Cancel Report Mistake" : "Report Mistake"}
        </span>
      </button>

      <ConfirmPopup
        blur
        isOpen={open && !isReported}
        title="Report mistake"
        message={
          <div style={{ textAlign: "center" }}>
            <MdOutlineReportProblem size={48} color="#f5222d" style={{ marginBottom: "12px" }} />
            <div style={{ color: "#444", fontSize: "13px", lineHeight: "1.7", textAlign: "left" }}>
              <p style={{ margin: "0 0 8px 0" }}>
                Very rarely, the data extraction from a document might have a mistake.
                If you think this has happened, please click <strong>report mistake</strong>.
              </p>
              <p style={{ margin: "0 0 8px 0" }}>
                You can try resubmitting the document although we can't guarantee a fix for the mistake.
              </p>
              <p style={{ margin: 0, color: "#888" }}>Thank you for your feedback.</p>
            </div>
          </div>
        }
        confirmLabel="Report mistake"
        cancelLabel="Cancel"
        confirmColor="var(--color-brand)"
        onConfirm={() => {
          setOpen(false);
          onReportedChange(true);
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export default ReportMistakeButton;
